module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body",
    style: (_vm.height)
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "id": _vm.id
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, _vm._l((_vm.names), function(val, key, index) {
    return _c('th', {
      key: key,
      attrs: {
        "id": _vm.id + '-name-' + key
      }
    }, [_vm._v("\n          " + _vm._s(val.name) + "\n          "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (val.icon),
        expression: "val.icon"
      }],
      staticClass: "fa",
      class: val.icon,
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), 0)]), _vm._v(" "), _vm._l((_vm.data), function(row, key, index) {
    return _c('tbody', {
      key: key,
      attrs: {
        "id": _vm.id + '-body'
      }
    }, [_c('tr', {
      staticClass: "info"
    }, _vm._l((row), function(r, k, i) {
      return (k !== 'id') ? _c('td', {
        key: k,
        attrs: {
          "id": _vm.id + '-body-' + k
        }
      }, [_c('div', [(k !== 'alarmaAsignada') ? _c('p', [_vm._v(" " + _vm._s(r) + " ")]) : _vm._e()])]) : _vm._e()
    }), 0)])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daec1c7c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/SingleTable.vue
// module id = 1720
// module chunks = 6